/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:06:50
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/overlay.js
 */
export default {
    // overlay组件
    overlay: {
        show: false,
        zIndex: 9,
        duration: 300,
        opacity: 0.5
    }
}
